import { render, staticRenderFns } from "./DatasetTextCategorization.vue?vue&type=template&id=4e062dc2&scoped=true&"
import script from "./DatasetTextCategorization.vue?vue&type=script&lang=js&"
export * from "./DatasetTextCategorization.vue?vue&type=script&lang=js&"
import style0 from "./DatasetTextCategorization.vue?vue&type=style&index=0&id=4e062dc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e062dc2",
  null
  
)

export default component.exports